import { ZoomOut } from 'lucide-react';
import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { ControllerAutoZoomSupport } from './types';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type ZoomOutFeatureParams = FeatureHoookParams;

export const useZoomOutFeature = (params: ZoomOutFeatureParams = {}): Feature<number> => {
	const [controller] = useDesign<Controller, ControllerAutoZoomSupport>();
	// const controller = params.controller as (typeof params.controller) & ControllerAutoZoomSupport;

	const controllerSupportsAutozoomFeature = (controller?.viewport?.config?.autoZoom ?? null) !== null;
	const autozoom = controllerSupportsAutozoomFeature ? controller?.viewport?.config?.autoZoom ?? false : false;

	useSubscription(controller as Controller, false, [['viewport-config', 'updated']]);

	const [enabled, tooltip] = (() => {
		if (autozoom) return [false, lang.zoom.message.disabled4AutoZoom];
		if (!controller || controller.viewport.config.zoom <= controller.viewport.config.minZoom) return [false, lang.zoom.message.minZoomAcheived];
		return [true, lang.zoom.tooltip.zoomOut];
	})();

	return {
		name: 'zoomOut',
		label: lang.zoom.tooltip.zoomOut,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <ZoomOut {...props}/>,
		disabled: !enabled,
		value: controller?.viewport?.config?.zoom ?? 1,
		hidden: false,
		handler: () => {
			if (controller && controller.viewport) {
				let newZoom = (controller?.viewport?.state?.targetZoom ?? 1) - controller.viewport.config.zoomStep;
				if (newZoom < controller.viewport.config.minZoom) newZoom = controller.viewport.config.minZoom;
				controller.viewport.actions.smoothZoom(newZoom);
				// controller.viewport.updateConfig({ zoom: newZoom < controller.viewport.config.minZoom ? controller.viewport.config.minZoom : newZoom });
			}
		}
	};
};
